import React, {useState} from "react";
import axios from "axios";
import {NavLink, useHistory} from "react-router-dom";
import * as config from "../../configs/Config";
import AuthShell, {AuthButton, AuthError, AuthInput, AuthLabel} from "./AuthShell";

/** Landing page of the email reset link: /reset-password?token=…&email=… */
export default function ResetPassword() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');
    const history = useHistory();

    const [form, setForm] = useState({password: '', confirm: ''});
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async () => {
        if (form.password.length < 8) return setError('Password needs at least 8 characters');
        if (form.password !== form.confirm) return setError("Passwords don't match");
        setBusy(true);
        try {
            await axios.post(`${config.API_URL}/reset-password`, {
                email, token, password: form.password,
            }, {headers: {Accept: 'application/json'}});
            setDone(true);
            setTimeout(() => history.push('/login'), 2500);
        } catch (err) {
            setError(err.response?.data?.message || err.message);
            setBusy(false);
        }
    };

    if (!token || !email) {
        return (
            <AuthShell>
                <p className="mt-6 text-center text-[13.5px] text-white/60">This reset link is incomplete.</p>
                <p className="mt-5 text-center text-[13px] text-white/40">
                    <NavLink to="/forgot-password" className="font-bold text-white hover:text-apple-red">Request a new one</NavLink>
                </p>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <h1 className="font-heading mt-5 text-center text-[26px] font-bold tracking-[-0.015em]">Choose a new password</h1>
            {done ? (
                <p className="mt-4 text-center text-[13.5px] text-white/60">
                    Password updated. Taking you to login…
                </p>
            ) : (
                <>
                    <p className="mb-6 mt-1 text-center text-[13px] text-white/40">for {email}</p>
                    <AuthLabel htmlFor="rp-password">New password</AuthLabel>
                    <AuthInput id="rp-password" type="password" placeholder="8+ characters"
                               onChange={e => { setError(null); setForm({...form, password: e.target.value}); }}/>
                    <AuthLabel htmlFor="rp-confirm">Confirm password</AuthLabel>
                    <AuthInput id="rp-confirm" type="password"
                               onChange={e => { setError(null); setForm({...form, confirm: e.target.value}); }}/>
                    <AuthButton onClick={submit} disabled={busy}>{busy ? 'Saving…' : 'Save new password'}</AuthButton>
                    <AuthError error={error}/>
                </>
            )}
        </AuthShell>
    );
}
